import * as React from 'react';
import { Container } from 'types/Watchlist';
import { DualCell } from './DualCell';
import { CellProps } from './types';

export const YardLocation: React.FC<CellProps> = (props) => {
  const container: Container = props.row;
  const yardLocation = container.pickupInfo?.yardLocation;

  const topText = yardLocation?.location || '';
  const showBottomText = !!topText;
  const bottomTextRed = yardLocation?.closedArea;
  const bottomText = `Closed Area: ${yardLocation?.closedArea ? 'YES' : 'NO'}`;

  return (
    <DualCell
      topText={topText}
      bottomText={bottomText}
      showBottomText={showBottomText}
      bottomTextRed={bottomTextRed}
    />
  );
};
YardLocation.displayName = 'ContainerTable.YardLocation';
